import './style.scss';

import Vue from 'vue';

import store from './store';

import App from './components/App.vue';

let creators = window.__INITIAL_STATE__.map(creator => {
  return {
    name: creator.name,
    twitterHandle: creator.twitterHandle,
    websiteUrl: creator.websiteUrl,
    profileUrl: creator.profileUrl,
    categorySelect: creator.categorySelect
  }
});

let initialState = Object.assign({}, store.state, { creators });
store.replaceState(initialState);

new Vue({
  el: '#app',
  components: {
    App
  },
  store
});



// WEBPACK FOOTER //
// ./src/web.entry.js